import update from 'react-addons-update';
import * as Common from '../Components/CommonControlls/CommonJs';

const iState = {
  AuthToken: "",
  UserInfo: null,
}

const UserAuthentication = (state = iState, action) => {
  switch (action.type) {
    case 'UpdatAuth':
      return {
        AuthToken: action.payload.token,
        UserInfo: action.payload.userobj,
      }
    // return update(state, {
    //   AuthToken:{$set: action.payload.token},
    //   UserInfo:{$set: action.payload.userobj},
    // });

    case 'UpdateProfileChanges':
      return update(state, {
        UserInfo: {
          name: { $set: action.payload.name },
          contact: { $set: action.payload.contact },
          email: { $set: action.payload.email },
          address: { $set: action.payload.address },
          imageURL: { $set: action.payload.imageURL },
          imageURLBase64: { $set: action.payload.imageURLBase64 },
          vehicleNumber: { $set: action.payload.vehicleNumber },
          vehicleModel: { $set: action.payload.vehicleModel },
        },
      });

    default:
      return state;
  }

}

export default UserAuthentication;